@if (isLoading) {
<div class="panel-title-dummy">
  <div class="shine"></div>
</div>
<div class="panel-dummy">
  <div class="shine"></div>
</div>

<div class="panel-title-dummy">
  <div class="shine"></div>
</div>
<div class="panel-dummy">
  <div class="shine"></div>
</div>
<div class="panel-dummy">
  <div class="shine"></div>
</div>
<div class="panel-dummy">
  <div class="shine"></div>
</div>
}
@else {
<div class="margin-above" [ngClass]="{'dialog-view-wrapper-empty': connections.length === 0}">

  <ng-container *ngIf="connections.length > 0; then lastConnections else noConnections"> </ng-container>

  <ng-template #lastConnections>

    <h2 class="panel-title">{{('Modules.RemoteMaintenance.RemoteConnections.LastConnectionDetails' | translate)}}</h2>
    <div class="details-card">
      <!-- User -->
      <div>
        <h4 class="detail-type">{{ 'Modules.RemoteMaintenance.RemoteConnections.User' | translate }}</h4>
        <div class="detail-value">{{ getUserDisplayName(connections[0]) }}</div>
      </div>

      <!-- StartTime -->
      <div *ngIf="connections[0].startUtc">
        <h4 class="detail-type">{{ 'Modules.RemoteMaintenance.RemoteConnections.StartTime' | translate }}</h4>
        <div class="detail-value">{{ ((connections[0].startUtc | localizedDate: 'short') || ('General.NotAvailableShort'
          | translate)) }}</div>
      </div>

      <!-- EndTime -->
      <div>
        <h4 class="detail-type">{{ 'Modules.RemoteMaintenance.RemoteConnections.EndTime' | translate }}</h4>
        <div class="detail-value">{{ ((connections[0].endUtc | localizedDate: 'short') || ('General.NotAvailableShort' |
          translate)) }}</div>
      </div>

      <!-- Duration -->
      <div>
        <h4 class="detail-type">{{ 'Modules.RemoteMaintenance.RemoteConnections.Duration' | translate }}</h4>
        <div class="detail-value">{{ getDurationString(connections[0]) }}</div>
      </div>

      <!-- MaskedIpAddress -->
      <div>
        <h4 class="detail-type">{{ 'Modules.RemoteMaintenance.RemoteConnections.MaskedIpAddress' | translate }}</h4>
        <div class="detail-value">{{ (connections[0].remoteIP) || ('General.NotAvailableShort' | translate) }}</div>
      </div>
    </div>

    <h2 class="panel-title">{{('Modules.RemoteMaintenance.RemoteConnections.ConnectionHistory' | translate)}}</h2>
    <app-list-item *ngFor="let log of connections| slice:1;" title="{{ getTitle(log) }}" info="{{ getInfo(log) }}"
      [showActionIcon]="false">
    </app-list-item>
  </ng-template>

  <ng-template #noConnections>
    <div class="panel-no-data">{{ 'Modules.RemoteMaintenance.RemoteConnections.NoConnections' | translate }}</div>
  </ng-template>
</div>
}